import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import {
  legalAssociationsViolentActsItemValidator,
  legalAssociationsViolentActsItemWithWasValidator,
} from './validators/items';
import { LegalAssociationsViolentActsModel } from './types';

const legalAssociationsViolentActsValidator: ValidateJSModel<LegalAssociationsViolentActsModel> = {
  HasViolentAct: { presence: true, hasValue: { validator: hasYesOrNo } },

  HateCrimes: (value, attributes, attributeName, options) => {
    if (attributes?.HasViolentAct?.value === 'Yes') {
      return {
        presence: true,
        branchCollection: { validator: legalAssociationsViolentActsItemValidator },
      };
    }

    return {};
  },
  GovermentOfficials: (value, attributes, attributeName, options) => {
    if (attributes?.HasViolentAct?.value === 'Yes') {
      return {
        presence: true,
        branchCollection: { validator: legalAssociationsViolentActsItemValidator },
      };
    }

    return {};
  },
  GovernmentProperty: (value, attributes, attributeName, options) => {
    if (attributes?.HasViolentAct?.value === 'Yes') {
      return {
        presence: true,
        branchCollection: { validator: legalAssociationsViolentActsItemWithWasValidator },
      };
    }

    return {};
  },
};

export default legalAssociationsViolentActsValidator;
